import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { LifeComponent } from 'src/app/view/life/life.component';
import { ClubsComponent } from 'src/app/view/life/clubs/clubs.component';
import { HousesComponent } from 'src/app/view/life/houses/houses.component';
import { RouterModule } from '@angular/router';
import { WorkshopComponent } from 'src/app/view/life/workshop/workshop.component';
import { SocialComponent } from 'src/app/view/life/social/social.component';
import { ExpeditionsComponent } from 'src/app/view/life/expeditions/expeditions.component';
import { CampsComponent } from 'src/app/view/life/camps/camps.component';



@NgModule({
  declarations: [
    LifeComponent,
    HousesComponent,
    ClubsComponent,
    WorkshopComponent,
    SocialComponent,
    ExpeditionsComponent,
    CampsComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path:'', component:LifeComponent, children: [
        {path:'houses',component:HousesComponent},
        {path:'clubs',component:ClubsComponent},
        {path:'workshop',component:WorkshopComponent},
        {path:'social',component:SocialComponent},
        {path:'expeditions',component:ExpeditionsComponent},
        {path:'camps',component:CampsComponent},
      ]}
    ]),
    SharedModule
  ]
})
export class LifeModule { }
